
  import { defineComponent } from 'vue';
  import { Logo } from '@/ui/components/Logo';

  export default defineComponent({
    components: { Logo },
    setup() {
      return {
        link: process.env.VUE_APP_WEBSITE_URL,
      };
    },
  });
